module.exports = __webpack_public_path__ + "img/instagram-story.be311dc0.png";